function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets/icons/ic_inverted_up_2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 48,
  height: 28
}), React.createElement("rect", {
  id: "background",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 48,
  height: 28,
  rx: 14
}), React.createElement("path", {
  d: "M18.0369594,23.0000851 L18.149513,22.9934596 C18.5924713,22.9407322 18.9439154,22.580624 18.9953306,22.1267712 L19.0018132,22.0114786 L19.0014293,8.57974247 L21.3898027,11.0271577 C21.5572737,11.1987466 21.8172365,11.217812 22.0052613,11.084354 L22.0720773,11.0271577 L22.754352,10.3281074 C22.9192063,10.1591996 22.9398131,9.89846427 22.8161723,9.70659961 L22.754352,9.62905699 L18.3776883,5.14487806 L18.3108682,5.08764397 C18.203213,5.01124324 18.0719812,4.98484077 17.9480343,5.00843708 C17.8243821,4.9846988 17.6927328,5.01103731 17.5847874,5.08764397 L17.5179674,5.14487806 L13.1413037,9.62905699 C12.9528988,9.82209442 12.9528988,10.1350699 13.1413037,10.3281074 L13.8235783,11.0271577 C14.0119833,11.2201952 14.3174481,11.2201952 14.505853,11.0271577 L16.8942264,8.57974247 L16.8938425,22.0114786 C16.8938018,22.5184714 17.2662712,22.9363382 17.7461426,22.9934596 L17.8586963,23.0000851 L17.9478278,22.9950851 L18.0369594,23.0000851 Z M30.1369594,23.0000851 L30.249513,22.9934596 C30.6924713,22.9407322 31.0439154,22.580624 31.0953306,22.1267712 L31.1018132,22.0114786 L31.1014293,8.57974247 L33.4898027,11.0271577 C33.6572737,11.1987466 33.9172365,11.217812 34.1052613,11.084354 L34.1720773,11.0271577 L34.854352,10.3281074 C35.0192063,10.1591996 35.0398131,9.89846427 34.9161723,9.70659961 L34.854352,9.62905699 L30.4776883,5.14487806 L30.4108682,5.08764397 C30.303213,5.01124324 30.1719812,4.98484077 30.0480343,5.00843708 C29.9243821,4.9846988 29.7927328,5.01103731 29.6847874,5.08764397 L29.6179674,5.14487806 L25.2413037,9.62905699 C25.0528988,9.82209442 25.0528988,10.1350699 25.2413037,10.3281074 L25.9235783,11.0271577 C26.1119833,11.2201952 26.4174481,11.2201952 26.605853,11.0271577 L28.9942264,8.57974247 L28.9938425,22.0114786 C28.9938018,22.5184714 29.3662712,22.9363382 29.8461426,22.9934596 L29.9586963,23.0000851 L30.0478278,22.9950851 L30.1369594,23.0000851 Z",
  id: "Shape",
  fill: "#ffcc00"
}));

const SvgIcWhiteBadgeUp2 = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "28px",
    viewBox: "0 0 48 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIcWhiteBadgeUp2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_white_badge_up_2.1a32d130.svg";
export { ForwardRef as ReactComponent };